module.exports = __webpack_public_path__ + "static/img/login_column_two04.35d32ecd.png";